module.exports = __webpack_public_path__ + "static/turtle-creek-house44-cca7b3f264f1fb86d8f21252d3079914.jpg";